import { render, staticRenderFns } from "./PrescriptionView.vue?vue&type=template&id=d4c3bdde&scoped=true"
import script from "./PrescriptionView.vue?vue&type=script&lang=ts"
export * from "./PrescriptionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c3bdde",
  null
  
)

export default component.exports